<!-- =========================================================================================
  File Name: time.vue
  Description: Lottery Time
========================================================================================== -->

<template>
  <div id="lottery-time">

    <vx-card title="时间设置">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <vs-select class="w-48" v-model="shortname">
              <vs-select-item :key="index" :value="item.shortname" :text="item.name" v-for="(item, index) in lotteryName" />
            </vs-select>
          </template>
          <vs-input class="w-48" v-model="number" placeholder="输入期号" />
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无开奖时间">
        <template slot="thead">
          <vs-th width="250">彩种名称</vs-th>
          <vs-th width="250">期号</vs-th>
          <vs-th width="400">开盘时间</vs-th>
          <vs-th width="400">封盘时间</vs-th>
          <vs-th width="400">开奖时间</vs-th>
          <vs-th width="300">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.shortname">{{lotteryList[item.shortname] ? lotteryList[item.shortname].name : ''}}</vs-td>
            <vs-td :data="item.number">{{item.number}}</vs-td>
            <vs-td :data="item.start">
              <vs-input v-model="item.start" class="w-full" />
            </vs-td>
            <vs-td :data="item.feng">
              <vs-input v-model="item.feng" class="w-full" />
            </vs-td>
            <vs-td :data="item.kaijiang">
              <vs-input v-model="item.kaijiang" class="w-full" />
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      lotteryList: {},
      lotteryName: [{ shortname: '', name: '选择彩种' }],
      shortname: '',
      number: ''
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    modify (e) {
      const dataset = e.currentTarget.dataset
      const postdata = this.list[dataset.index]
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('lottery-timeDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.shortname = this.shortname
      postdata.number = this.number
      this.$utils.post('lottery-timeList', postdata).then(res => {
        let t
        for (let i = 0; i < res.list.length; i++) {
          t = res.list[i].start
          res.list[i].start = t.substr(0, 2) + ':' + t.substr(2, 2) + ':' + t.substr(4, 2)
          t = res.list[i].feng
          res.list[i].feng = t.substr(0, 2) + ':' + t.substr(2, 2) + ':' + t.substr(4, 2)
          t = res.list[i].kaijiang
          res.list[i].kaijiang = t.substr(0, 2) + ':' + t.substr(2, 2) + ':' + t.substr(4, 2)
        }
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    search() {
      this.page = 1
      this.load()
    },
  },
  mounted () {
    this.load()

    this.$utils.post('lottery-lotteryAll', { authKey: localStorage.getItem('authKey') }).then(res => {
      for (let i = 0; i < res.length; i++) {
        this.lotteryList[res[i].shortname] = res[i]
        this.lotteryName.push({ shortname: res[i].shortname, name: res[i].name })
      }
      this.$forceUpdate()
    })
  }
}
</script>
